<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icon_taiyangdianji">
      <path id="Ellipse 96"
        d="M12.2111 17.0803C11.6291 17.2471 11.0284 17.3402 10.4232 17.3575L10.3715 15.5482C10.8255 15.5352 11.276 15.4653 11.7125 15.3402L12.2111 17.0803Z"
        :fill="color" fill-opacity="0.6" />
      <path id="Ellipse 98"
        d="M4.18776 14.0203C3.85145 13.534 3.57748 13.0073 3.37226 12.4528L5.03015 11.8393C5.18407 12.2552 5.38955 12.6502 5.64178 13.0149L4.18776 14.0203Z"
        :fill="color" fill-opacity="0.6" />
      <path id="Ellipse 100"
        d="M4.61011 5.42298C4.99286 4.97225 5.43064 4.57131 5.9132 4.22955L6.9349 5.67217C6.57298 5.92848 6.24465 6.22919 5.95758 6.56723L4.61011 5.42298Z"
        :fill="color" fill-opacity="0.6" />
      <path id="Ellipse 102"
        d="M13.0222 3.60885C13.5567 3.8619 14.0572 4.18099 14.5123 4.55865L13.3832 5.91891C13.042 5.63567 12.6665 5.39635 12.2657 5.20656L13.0222 3.60885Z"
        :fill="color" fill-opacity="0.6" />
      <path id="Ellipse 95"
        d="M15.756 14.1236C15.4132 14.6026 15.0118 15.037 14.5613 15.4165L13.4224 14.0645C13.7603 13.7799 14.0613 13.4541 14.3184 13.0948L15.756 14.1236Z"
        :fill="color" fill-opacity="0.6" />
      <path id="Ellipse 97"
        d="M7.51841 16.6196C6.96693 16.4124 6.44349 16.1372 5.96028 15.8002L6.97143 14.3502C7.33384 14.6029 7.72642 14.8093 8.14003 14.9647L7.51841 16.6196Z"
        :fill="color" fill-opacity="0.6" />
      <path id="Ellipse 99"
        d="M2.96636 9.31022C3.02372 8.72392 3.15412 8.14708 3.35454 7.59311L5.01686 8.19451C4.86655 8.60999 4.76875 9.04262 4.72573 9.48235L2.96636 9.31022Z"
        :fill="color" fill-opacity="0.6" />
      <path id="Ellipse 101"
        d="M8.84361 3.02413C9.42479 2.92779 10.0157 2.90445 10.6027 2.95466L10.452 4.716C10.0118 4.67834 9.56859 4.69584 9.13271 4.7681L8.84361 3.02413Z"
        :fill="color" fill-opacity="0.6" />
      <path id="Ellipse 103"
        d="M16.4351 7.07723C16.6785 7.61366 16.854 8.17842 16.9574 8.75838L15.2171 9.06871C15.1396 8.63374 15.0079 8.21017 14.8253 7.80784L16.4351 7.07723Z"
        :fill="color" fill-opacity="0.6" />
      <path id="Ellipse 104"
        d="M17.0336 10.6888C16.9763 11.2751 16.8459 11.8519 16.6455 12.4059L14.9831 11.8045C15.1335 11.389 15.2313 10.9564 15.2743 10.5167L17.0336 10.6888Z"
        :fill="color" fill-opacity="0.6" />
      <circle id="Ellipse 92" cx="10.0093" cy="10.0084" r="3.89118" :fill="color" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'sun',
  props: {
    color: {
      type: String,
      default: '#376eff'
      // default: 'white'
    }
  },
  data() {
    return {
      style: {
        'vertical-align': 'middle',
        overflow: 'hidden',
      }
    }
  }
}
</script>